import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  ONBOARDING_CUSTOMER_COPY,
  onboardingCustomerCopyForSession,
} from "@/lib/onboarding-customer-copy";

export const Route = createFileRoute("/contratar/pendiente")({
  component: ContratarPendientePage,
  head: () => ({
    meta: [
      { title: "Activación de tu tienda — Structura Market" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

/**
 * Thin status page for payUrl (`/contratar/pendiente?session=`).
 * Does not create a second payment state. Ualá provider return remains
 * `/contratar?session=&uala=success|failed`.
 */
function ContratarPendientePage() {
  const [message, setMessage] = useState<string>(ONBOARDING_CUSTOMER_COPY.paymentPending);
  const [status, setStatus] = useState<string | null>(null);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session");
    if (!sessionId) return;
    let cancelled = false;
    const tick = async () => {
      const res = await fetch(`/api/self-service/session?id=${encodeURIComponent(sessionId)}`);
      if (!res.ok || cancelled) return;
      const data = (await res.json()) as { status?: string; paymentConfirmedAt?: string | null };
      if (!data.status) return;
      setStatus(data.status);
      setMessage(onboardingCustomerCopyForSession({
        status: data.status,
        paymentConfirmedAt: data.paymentConfirmedAt ?? null,
      }));
    };
    void tick();
    const id = window.setInterval(() => { void tick(); }, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border border-border/50 bg-card p-8 shadow-sm text-center space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Activación de tu tienda</h1>
        <p className="text-muted-foreground">{message}</p>
        {status === "active" ? (
          <Button asChild>
            <Link to="/acceso/comercio" search={{ returnTo: undefined, error: undefined }}>Ir al panel →</Link>
          </Button>
        ) : (
          <Button asChild variant="outline">
            <Link to="/contratar">Volver a contratar</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
